export const version = "ethers/5.6.5";
//# sourceMappingURL=_version.js.map